import * as React from 'react';

const SvgDepartment = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 9C4.08579 9 3.75 9.33579 3.75 9.75V12C2.92157 12 2.25 12.6716 2.25 13.5V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H14.25C15.0784 15.75 15.75 15.0784 15.75 14.25V13.5C15.75 12.6716 15.0784 12 14.25 12V9.75C14.25 9.33579 13.9142 9 13.5 9C13.0858 9 12.75 9.33579 12.75 9.75V12H11.25V9.75C11.25 9.33579 10.9142 9 10.5 9C10.0858 9 9.75 9.33579 9.75 9.75V12H8.25V9.75C8.25 9.33579 7.91421 9 7.5 9C7.08579 9 6.75 9.33579 6.75 9.75V12H5.25V9.75C5.25 9.33579 4.91421 9 4.5 9Z"
      fill="currentColor"
    />
    <path
      d="M2.25 5.56747C2.25 4.92844 2.65485 4.35957 3.25862 4.15023L8.50862 2.32996C8.82691 2.2196 9.17309 2.2196 9.49138 2.32996L14.7414 4.15023C15.3451 4.35957 15.75 4.92844 15.75 5.56747V5.99994C15.75 6.82837 15.0784 7.49994 14.25 7.49994H3.75C2.92157 7.49994 2.25 6.82837 2.25 5.99994V5.56747Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDepartment;
